import React from 'react';

import Features from 'components/Features';

import illustrations from './illustrations';
import Wrap from './styled/Wrap';
import images from './images';

const Steps: React.FC = () => (
  <Wrap>
    <Features
      base="business.organizations.index.steps"
      keys={['step1', 'step2', 'step3', 'step4']}
      illustrations={illustrations}
      images={images}
      imageSize={80}
    />
  </Wrap>
);

export default Steps;
